import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { IMAGES_ASSETS_URL } from '../../../constants/links';
import { IPaymentCardCommonData } from '../../../models/common/payments';

export const GiftCardLogoAndNumber = ({
  card,
  shouldShowInactive = false,
}: {
  card: IPaymentCardCommonData;
  shouldShowInactive?: boolean;
}) => {
  const { cardStatus } = card;
  const isCardInactive = cardStatus?.toLowerCase() === 'inactive';

  let cardTextColor = 'primary';
  if (shouldShowInactive) {
    cardTextColor = isCardInactive ? 'inactive' : 'subtle';
  }
  return (
    <>
      <img
        width={50}
        height="auto"
        className="sui-inline-block sui-mr-4"
        // TODO use sui-grayscale class instead of style prop when stencil fix this class
        style={
          shouldShowInactive && isCardInactive
            ? { filter: 'grayscale(1)' }
            : undefined
        }
        src={`${IMAGES_ASSETS_URL}/HD_Gift.png`}
        alt="Gift card logo"
      />
      {card.cardNumberLast4 && (
        <div>
          <Typography variant="body-lg" color={cardTextColor}>
            **** ******** {card.cardNumberLast4} *******
          </Typography>
        </div>
      )}
    </>
  );
};

GiftCardLogoAndNumber.displayName = 'GiftCardLogoAndNumber';
